import React from 'react';

export let CheckBox = function (props) {
    function onChange() {
        props.onChange(props.fieldName, !props.checked);
    }

    let idProps = {};
    if (props.id) {
        idProps.id = props.id;
    }

    return (
        <div
            className="common-form-checkbox"
            onClick={onChange}
            {...idProps}
        >
            {(() => {
                if (props.checked) {
                    return (
                        <img
                            src="/static/images/check-textcolor.svg"
                            className="common-form-checkbox-check"
                        />
                    )
                }
            })()}
        </div>
    );
};
